module.exports = __webpack_public_path__ + "img/snow_fall_00018.48dbf26e.png";